import SlideVerify from './slide-verify.vue'

const plugins = {
  install(Vue) {
      Vue.component(SlideVerify.name, SlideVerify)
  }
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(SlideVerify)
}

export default plugins



//////////////////
// WEBPACK FOOTER
// ./static/puligin/vue-monoplasty-slide-verify/index.js
// module id = null
// module chunks = 